import {Reducer} from "redux";
import {IApplicationState, ILayerState} from "../types";
import {fromJS} from "immutable";
import {createFeatureCollection} from "../../utils/createFeatureCollection";
import {createSource} from "../../utils/createSource";
import {createLayerState} from "../../utils/createLayerState";
import {insertLayer} from "./insertLayer";
import {IFeature_Collection_CONO} from "../../types";

interface ILayer {
    layerId: number;
    type: string;
    geoType: string;
    layername: string;
}

const reducer: Reducer<IApplicationState['map']> = (state, action) => {
    let mapStyle = state?.mapStyle!;
    const layerState: ILayerState = {...state?.layerState};
    const layerNamesByType = {...state?.layerNamesByType};
    const layersByType = {...state?.layersByType};
    let layerIds: string[] = [];
    const databaseLayerIds = {...state?.databaseLayerIds};
    const {data = []}: {data: Array<ILayer>} = action.payload;
    // check for deleted layers, maybe theres a better way
    const layerIdExistsCheck: {[key: string]: boolean} = {};
    for (const layer of data) {
        const layerType = layer.type;
        const geoType = layer.geoType;
        const _state = createLayerState(layer.layername, {
            layerType,
            geoType
        });
        if (layerState[layerType]) {
            _state.visibility = layerState[layerType].visibility;
            _state.isLoading = layerState[layerType].isLoading;
        }
        layerState[layerType] = _state;
        layerNamesByType[layerType] = layer.layername;
        layersByType[layerType] = createFeatureCollection([]) as any;
        databaseLayerIds[layerType] = layer.layerId;
        layerIdExistsCheck[layerType] = true;
        const sourceKeyPath = ['sources', layerType];
        const newLayer = !mapStyle.getIn(sourceKeyPath);
        const newSource = fromJS(
            createSource(
                layersByType[layerType] as any as IFeature_Collection_CONO
            )
        );
        // initialize feature collections and layers
        if (newLayer) {
            mapStyle = mapStyle.setIn(sourceKeyPath, newSource);
            mapStyle = insertLayer(mapStyle, layerType, geoType);
        }
        layerIds.push(layerType);
    }
    let layers = mapStyle.get('layers');
    layerIds
        // get deleted / missing layerTypes
        .filter(layerType => !layerIdExistsCheck[layerType])
        .forEach(layerType => {
            layers = layers.filter(layer => layer.get('id') !== layerType);
            mapStyle = mapStyle.deleteIn(['sources', layerType]);
            layerIds = layerIds.filter(id => id !== layerType);
            delete layerState[layerType];
            delete databaseLayerIds[layerType];
            delete layerNamesByType[layerType];
    })
    mapStyle = mapStyle.set('layers', layers);
    return {...state, mapStyle, layerIds, databaseLayerIds,
        layerNamesByType, layersByType, layerState} as IApplicationState['map'];
};


export { reducer as loadLayerMetadata };
